// DS: MO5.3
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton/TextButton';
import AdoptableButton from '@wix/da-ds/pkg/Buttons/AdoptableButton';
import { pushAdoptsSellerModal } from '../../../../../../Modals/redux/actionCreators';
import ConditionalWrapper from '../../../../../../ConditionalWrapper';
import UserAvatar from '../../../../../../User/Avatar/UserAvatar';
import UserLink from '../../../../../../User/Link/UserLink';
import Timestamp from '../../../../../../Timestamp/Timestamp';
import { formatDollars as originalFormatDollars, OPTIONAL_DECIMAL_DIGITS } from '../../../../../../utils/formatting';
import { getSellableAs } from '../../../../../../types/deviation/getters';
import { SellableAs } from '../../../../../../types/deviation';
import s from './AdoptedOnSide.scss';
// Avoid showing decimal digits unless necessary
const formatDollars = (amount)=>originalFormatDollars(amount, OPTIONAL_DECIMAL_DIGITS);
function getSellPrice(deviation) {
    var _deviation_adoptable;
    const { fixedPrice, offers } = (_deviation_adoptable = deviation.adoptable) !== null && _deviation_adoptable !== void 0 ? _deviation_adoptable : {};
    if (offers) {
        return offers.offerPrice;
    } else if (fixedPrice) {
        return fixedPrice.fixedPrice;
    }
}
const AdoptedOnSide = ({ deviation, className })=>{
    var _deviation_extended;
    const { t } = useTranslation();
    var _deviation_extended_adoptable;
    const { owner, isOwner, assetSourceUrl, lastTradeTs, resaleAllowed } = (_deviation_extended_adoptable = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable) !== null && _deviation_extended_adoptable !== void 0 ? _deviation_extended_adoptable : {};
    const downloadLink = isOwner && assetSourceUrl;
    const sellableAs = getSellableAs(deviation);
    const isResellOptionPresent = resaleAllowed && isOwner;
    const isResaleOptionEnabled = sellableAs.includes(SellableAs.AdoptableResale);
    const dispatchPushAdoptsSellerModal = useAction(pushAdoptsSellerModal);
    const openSellModal = useCallback(()=>{
        dispatchPushAdoptsSellerModal(deviation, 'sell-splash');
    }, [
        deviation,
        dispatchPushAdoptsSellerModal
    ]);
    const sellPrice = getSellPrice(deviation);
    if (!owner) {
        return null;
    }
    const details = [
        lastTradeTs && /*#__PURE__*/ React.createElement(Timestamp, {
            key: "timestamp",
            timestamp: lastTradeTs
        }),
        sellPrice && /*#__PURE__*/ React.createElement("span", {
            key: "sell-price"
        }, t('sidebar.adoptableInfo.adopted.sold', {
            price: formatDollars(sellPrice)
        }))
    ]// Pull out any null/undefined results
    .filter((detail)=>!!detail)// Then put a ' | ' between each remaining detail
    .reduce((accumulator, detail, index)=>index > 0 ? [
            ...accumulator,
            ' | ',
            detail
        ] : [
            detail
        ], []);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root-inner']
    }, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 24,
        user: owner
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['adopted-by']
    }, t('sidebar.adoptableInfo.adopted.adoptedBy', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        userLink: /*#__PURE__*/ React.createElement(UserLink, {
            className: s['username'],
            user: owner
        }, owner.username)
    })), /*#__PURE__*/ React.createElement("div", null, details), isResellOptionPresent && /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: !isResaleOptionEnabled,
        wrap: (children)=>/*#__PURE__*/ React.createElement(SimpleTooltip, {
                text: t('sidebar.adoptableInfo.adopted.sell.tooltip')
            }, children)
    }, /*#__PURE__*/ React.createElement(AdoptableButton, {
        className: s['margin-top'],
        priority: "primary",
        disabled: !isResaleOptionEnabled,
        onClick: openSellModal
    }, t('sidebar.adoptableInfo.adopted.sell.label'))), downloadLink && /*#__PURE__*/ React.createElement(TextButton, {
        className: s['margin-top'],
        href: downloadLink,
        size: "medium",
        variant: "main"
    }, t('sidebar.adoptableInfo.adopted.downloadLink'))));
};
AdoptedOnSide.displayName = 'AdoptedOnSide';
export default AdoptedOnSide;
